
import { FaBookOpen, FaBookmark, FaFacebookF, FaHospital } from "react-icons/fa6"
import { BsInstagram, BsYoutube } from "react-icons/bs"
import PopUp from "./popUp";
import useFetch from "../../../utils/useFetch";
import { DecodeHtml } from "../../../utils/decodeHtml";
import { PropTypes } from 'prop-types';
import { retrunAssets } from "../../../utils/getAssets";
const StudentGuidanceUnit = ({url}) => {

    const data = useFetch(url)
 

   
    const cards = [
        {
            icon: <FaHospital size={30} />,
            title: "Personal Counselling",
            description: `Counsellors will conduct counselling and guidance sessions for students in a confidential manner.`
        },
        {
            icon: <FaBookmark size={30} />,
            title: "Academic Counselling",
            description: `Academic matters such as course choice, study plan and learning support.`
        },
        {
            icon: <FaBookOpen size={30} />,
            title: "Career Counselling",
            description: `Students may need guidance and advice on career planning.`
        },
    ]
    const socialIcons = [
        {
            icon: <FaFacebookF />,
            text: 'Facebook',
            link: data?.properties?.facebookURL
        },

        {
            icon: <BsInstagram />,
            text: 'Instagram',
            link: data?.properties?.instagramURL
        },
        {
            icon: <BsYoutube />,
            text: 'Youtube',
            link: data?.properties?.youtubeURL
        },
    ]
    // const contacts = [
    //     {
    //         location: "Putrajaya campus",
    //         info: [
    //             {
    //                 name: "Mrs. Razana",
    //                 mobile: "+603-89287168"
    //             }
    //         ]

    //     },
    //     {
    //         location: "kshas campus",
    //         info: [
    //             {
    //                 name: "FATONAH BT MOHD ZAIDI",
    //                 mobile: "+03-89212020 ext 7591"
    //             },
    //             {
    //                 name: "PN. NUR ADILAH MOHD HAMZAH",
    //                 mobile: "+603-8921 2020 ext 5025"
    //             },
    //         ],

    //     },
    //     {
    //         location: "Level 4, Counselling Unit, UNITEN KSHAS",
    //         info: [
    //             {
    //                 name: "MOHD HAFIS BIN MOHAMAD",
    //                 mobile: "+609-455 2020 ext 3174, +6013-6009 737",
    //                 email: "mhafis@uniten.edu.my"
    //             },
    //         ],

    //     },
    // ]
   
    const heading = data?.properties?.Label
    const description = DecodeHtml({html:data?.properties?.content?.markup})
    const img = data?.properties?.image1 != null ? retrunAssets(data?.properties?.image1[0]?.url) : ""
    const contacts = DecodeHtml({html:data?.properties?.footerContent?.markup})
    const contactTitle = data?.properties?.title
    // const cards = data?.properties?.rightContent?.items?.map((item, index) => (
    //     {
    //         icon: item?.content?.properties?.icon,
    //         title: item?.content?.properties?.label,
    //         description: item?.content?.properties?.description
    //     }
    // ))
    return (
        <PopUp
            title={contactTitle}
            heading={heading}
            description={description}
            img={img} 
            cards={cards}
            socialIcons={socialIcons}
            contacts={contacts} />
    )
}
StudentGuidanceUnit.propTypes = {
    url: PropTypes.string
}
export default StudentGuidanceUnit